
export default function getFilterableAttributeGroupsByProductClasses(
    productClassIds,
    attributeRelations
) {
    const productClasses = attributeRelations.product_class
        .filter(t => productClassIds.includes(t.id));

    const attributeGroups = productClasses.reduce((result, productClass) => {
        const productFilterGroups = attributeRelations.product_filter_group
            .filter(item =>
                item.product_class_id === productClass.id &&
                result.every(group => group.id !== createGroupId(item))
            );

        if (productFilterGroups.length === 0) {
            return result;
        }

        return result.concat(productFilterGroups.map(item => {
            return {
                id: createGroupId(item),
                name: item.name,
                segment_size: item.segment_size,
                sort_order: item.sort_order,
            };
        }));
    }, []);

    attributeGroups.sort((a, b) => a.sort_order - b.sort_order);

    return attributeGroups;
}


function createGroupId(productFilterGroup) {
    if (productFilterGroup.product_attribute_group_id !== null) {
        return productFilterGroup.product_attribute_group_id;
    }

    return productFilterGroup.preset_type;
}
